import { ServiceCardWrapper } from 'ui/Card/ServiceCard.styled';
import styled from 'styled-components';
import { themeable } from 'themes/utils';
import { Grid } from 'ui/Grid';

export const Body = styled.main`
    padding: 20px 0;
    display: flex;
    flex-flow: column;
    gap: 10px;

    & ${ServiceCardWrapper} {
        cursor: inherit;
    }
`;

export const Header = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    text-align: center;
    justify-content: center;
    border-bottom: 1px solid ${themeable('sidebar.lineColor')};
`;

export const CardRow = styled.div`
    display: flex;
    flex-flow: row;
    gap: 10px;
`;

export const CardContainer = styled.div`
    flex: 1;
`;

export const FieldContainer = styled.div`
    width: 84px;
    height: auto;
`;

export const Footer = styled.footer`
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: flex-end;
    border-top: 1px solid ${themeable('sidebar.lineColor')};
    padding-top: 16px;
    gap: 16px;
`;

export const TotalRow = styled.div`
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
`;

export const Wrapper = styled.div`
    width: 100%;
    max-width: 676px;
    margin: 0 auto;
`;

export const DocumentsWrapper = styled.div`
    margin: 40px auto;
    max-width: 849px;
    width: 100%;
`;

export const DocumentsGrid = styled(Grid)`
    column-gap: 8px;
`;
